(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-buy-dock"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-buy-dock')) {
  customElements.define('bt-buy-dock', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.main = document.querySelector('main');
      this.select = this.querySelector('select');
      this.price = this.querySelector('[data-dock-price]');
      this.image = this.querySelector('img');
      this.button = this.querySelector('button');
      this.quantity = this.querySelector('[name="quantity"]');
      if (!this.main || !this.main.querySelector('button[id^="product-buy-btn-"]')) return;
      document.body.classList.add('bt-buy-dock-enabled');
      this.refresh = () => {
        this.frame = null;
        const sourceButton = this.main.querySelector('button[id^="product-buy-btn-"]');
        if (!sourceButton || !sourceButton.form) {this.hidden = true;return;}
        const sourceVariant = sourceButton.form.elements.namedItem('id');
        if (sourceVariant && sourceVariant.value !== this.lastSourceVariant) {
          this.lastSourceVariant = sourceVariant.value;
          if (Array.from(this.select.options).some(option => option.value === sourceVariant.value)) {
            this.select.value = sourceVariant.value;
            this.updateVariant();
          }
        }
        const sourceQuantity = sourceButton.form.elements.namedItem('quantity');
        this.quantity.value = sourceQuantity ? sourceQuantity.value : '1';
        this.hidden = sourceButton.getBoundingClientRect().bottom >= 0;
        const toolbar = document.getElementById('PBarNextFrame');
        const offset = toolbar ? Math.max(0, Math.min(90, window.innerHeight - toolbar.getBoundingClientRect().top)) : 0;
        this.style.bottom = (offset + 12) + 'px';
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.refresh);
      };
      this.select.addEventListener('change', () => this.updateVariant());
      this.main.addEventListener('change', this.schedule);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.main, {childList:true,subtree:true,attributes:true,attributeFilter:['value','checked']});
      this.updateVariant();
      this.refresh();
    }
    updateVariant() {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      this.price.textContent = option.dataset.price;
      this.button.disabled = option.disabled;
      if (option.dataset.image) {
        this.image.removeAttribute('srcset');
        this.image.src = option.dataset.image;
      }
    }
    disconnectedCallback() {
      if (this.schedule) {
        window.removeEventListener('scroll',this.schedule);
        window.removeEventListener('resize',this.schedule);
        this.main?.removeEventListener('change',this.schedule);
      }
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.classList.remove('bt-buy-dock-enabled');
    }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) document.querySelectorAll('bt-buy-dock').forEach(dock => {dock.updateVariant();dock.refresh?.();});
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-compliments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-compliments'))customElements.define('bt-compliments',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const normalize=value=>String(value||'').trim().toLowerCase().replace(/[’‘]/g,"'");
    const render=()=>{
      const reviews=[...document.querySelectorAll('.jdgm-carousel-item')];
      if(!reviews.length)return false;
      const matches=[...this.querySelectorAll('[data-proof-card]')].map(card=>({card,review:reviews.find(item=>normalize(item.querySelector('.jdgm-carousel-item__product-image')?.alt)===normalize(card.dataset.title)&&item.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim())})).filter(item=>item.review);
      if(matches.length<2)return false;
      matches.forEach(({card,review})=>{
        const score=review.querySelectorAll('.jdgm-carousel-item__review-rating .jdgm--on').length;
        const stars=card.querySelector('[data-proof-stars]');
        stars.textContent='★'.repeat(score)+'☆'.repeat(5-score);
        stars.setAttribute('aria-label',this.dataset.rating.replace('[rating]',score));
        card.querySelector('[data-proof-quote]').textContent='“'+review.querySelector('.jdgm-carousel-item__review-body').textContent.trim()+'”';
        card.querySelector('[data-proof-author]').textContent=review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim()||'';
        card.hidden=false;
      });
      this.hidden=false;
      this.source=document.querySelector('.jdgm-carousel-wrapper')?.closest('.shopify-section');
      this.source?.classList.add('bt-compliments-source');
      if(location.hash==='#'+this.id)requestAnimationFrame(()=>this.scrollIntoView({block:'start'}));
      return true;
    };
    if(render())return;
    this.observer=new MutationObserver(()=>{if(render()){this.observer.disconnect();clearTimeout(this.timeout);}});
    this.observer.observe(document.body,{childList:true,subtree:true});
    this.timeout=setTimeout(()=>this.observer.disconnect(),25000);
  }
  disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.timeout);this.source?.classList.remove('bt-compliments-source');this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-fit-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-fit-guide')){
  customElements.define('bt-fit-guide',class extends HTMLElement{
    connectedCallback(){
      const init=()=>{
        if(this.ready)return;
        const source=document.querySelector('#MainContent [id$="__page"]');
        const tables=source?[...source.querySelectorAll('table')]:[];
        if(tables.length<2)return;
        this.data=tables.slice(0,2).map(table=>[...table.rows].slice(1).map(row=>[...row.cells].map(cell=>cell.textContent.trim())));
        const sizes=['XS','S','M','L','XL','2XL','3XL'];
        if(!this.data.every(rows=>rows.length===7&&rows.every((row,index)=>row.length===5&&row[0]===sizes[index]&&row.slice(1).every(value=>Number.isFinite(Number(value))))))return;
        this.ready=true;this.size='M';this.unit=0;
        this.normalize=value=>({SMALL:'S',MEDIUM:'M',LARGE:'L',XXL:'2XL',XXXL:'3XL'})[String(value).toUpperCase()]||String(value).toUpperCase();
        const requested=this.normalize(new URL(location.href).searchParams.get('bt_size')||'M');
        if(sizes.includes(requested))this.size=requested;
        this.querySelector('input[value="'+this.size+'"]').checked=true;
        this.products=[...this.querySelectorAll('[data-guide-product]')].map(card=>({card,variants:JSON.parse(card.querySelector('[data-guide-variants]').textContent)}));
        this.addEventListener('change',event=>{
          if(event.target.name.startsWith('guide-size'))this.size=event.target.value;
          if(event.target.name.startsWith('guide-unit'))this.unit=Number(event.target.value);
          this.update();
        });
        this.dataset.ready='true';this.hidden=false;this.update();
      };
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    }
    update(){
      const unitLabel=this.querySelector('[name^="guide-unit"]:checked').nextElementSibling.textContent;
      const row=this.data[this.unit].find(row=>row[0]===this.size);
      this.querySelector('[data-guide-size]').textContent=this.size;
      this.querySelector('[data-guide-unit-name]').textContent=unitLabel;
      this.querySelector('[data-guide-caption]').textContent=unitLabel;
      this.querySelectorAll('[data-guide-metric]').forEach(metric=>{metric.textContent=row[Number(metric.dataset.guideMetric)+1];});
      this.querySelectorAll('[data-guide-column]').forEach(cell=>cell.classList.toggle('is-selected',cell.dataset.guideColumn===this.size));
      this.querySelectorAll('[data-guide-cell]').forEach(cell=>{
        const data=this.data[this.unit].find(row=>row[0]===cell.dataset.guideCell);
        cell.textContent=data[Number(cell.dataset.guideRow)+1];
        cell.classList.toggle('is-selected',cell.dataset.guideCell===this.size);
      });
      const scroller=this.querySelector('.bt-fit-guide__table-scroll');
      const selected=this.querySelector('[data-guide-column="'+this.size+'"]');
      if(scroller.scrollWidth>scroller.clientWidth){
        const labelWidth=this.querySelector('thead th').getBoundingClientRect().width;
        const offset=selected.getBoundingClientRect().left-scroller.getBoundingClientRect().left+scroller.scrollLeft;
        scroller.scrollTo({left:Math.max(0,offset-labelWidth-(scroller.clientWidth-labelWidth-selected.getBoundingClientRect().width)/2),behavior:'auto'});
      }
      let total=0,shown=0;
      this.products.forEach(({card,variants})=>{
        const variant=variants.find(variant=>variant.options.some(option=>this.normalize(option)===this.size));
        card.hidden=true;
        if(!variant)return;
        total++;
        if(shown>=3)return;
        shown++;card.hidden=false;card.href=variant.url;
        card.querySelector('[data-guide-option]').textContent=variant.title;
        card.querySelector('[data-guide-price]').textContent=variant.price;
      });
      const status=this.querySelector('[data-guide-status]');
      status.textContent=status.dataset.template.replace('__count__',total).replace('__size__',this.size);
      this.querySelector('[data-guide-empty]').hidden=total>0;
      const label={S:'Small',M:'Medium',L:'Large'}[this.size]||this.size;
      const browse=this.querySelector('[data-guide-browse]');
      const url=new URL(browse.href,location.origin);url.searchParams.set('filter.v.option.size',label);url.searchParams.set('filter.v.availability','1');browse.href=url.pathname+url.search;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-fit-room"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-scorecard')) {
  customElements.define('bt-scorecard', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('.bt-scorecard__fallback');
      const sourceTables = [...source.querySelectorAll('table')];
      if (sourceTables.length < 2) return;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.selected = this.dataset.selected;
      const badge = document.querySelector('[id^="ProductInfoWrapper"] .jdgm-prev-badge');
      const count = Number(badge?.dataset.numberOfReviews);
      const rating = Number(badge?.dataset.averageRating);
      if (count > 0 && rating > 0 && rating <= 5) {
        const signature = this.querySelector('.bt-scorecard__signature');
        const link = document.createElement('a'); link.href = '#judgeme_product_reviews';
        const label = document.createElement('span'); label.textContent = signature.dataset.reviewLabel;
        const score = document.createElement('strong'); score.textContent = '★ ' + rating.toFixed(1) + ' / 5';
        const reviews = document.createElement('small'); reviews.textContent = signature.dataset.reviewCount.replace('[count]',count);
        link.append(label,score,reviews); signature.replaceChildren(link);
      }
      this.tables = this.querySelector('.bt-scorecard__tables');
      const normalize = value => ({small:'s',medium:'m',large:'l','2x':'2xl',xxl:'2xl',xxxl:'3xl'})[value.toLowerCase().trim()] || value.toLowerCase().trim();
      this.normalize = normalize;
      for (const [unit, original] of sourceTables.slice(0,2).entries()) {
        const rows = [...original.querySelectorAll('tbody tr')].map(row => [...row.querySelectorAll('td')].map(cell => cell.textContent.trim())).filter(row => row.length === 5);
        const headings = [...original.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
        if (!rows.length || headings.length !== 5) return;
        const table = document.createElement('table');
        table.className = 'bt-scorecard__table';
        table.hidden = unit !== 0;
        table.dataset.unit = unit;
        const caption = document.createElement('caption');
        caption.className = 'visually-hidden';
        caption.textContent = this.querySelector('.bt-scorecard__size-heading h3').textContent + ' — ' + this.querySelector('[data-unit="'+unit+'"]').textContent;
        table.append(caption);
        const thead = table.createTHead();
        const header = thead.insertRow();
        const label = document.createElement('th');
        label.scope = 'col'; label.textContent = headings[0]; header.append(label);
        for (const row of rows) {
          const th = document.createElement('th'); th.scope = 'col';
          th.dataset.size = normalize(row[0]);
          const variant = this.variants.find(item => normalize(item.size) === normalize(row[0]) && this.matchesOptions(item));
          if (variant?.available) {
            const link = document.createElement('a'); link.href = variant.url + '#' + this.id; link.textContent = row[0]; link.dataset.variant = variant.id; th.append(link);
          } else {
            th.textContent = row[0]; th.classList.add('is-unavailable');
            th.setAttribute('aria-label', row[0] + ' — ' + this.querySelector('[data-sold-out]').dataset.soldOut);
          }
          header.append(th);
        }
        const tbody = table.createTBody();
        for (let measure=1; measure<5; measure++) {
          const tr = tbody.insertRow(); const th = document.createElement('th'); th.scope='row'; th.textContent=headings[measure]; tr.append(th);
          for (const row of rows) {
            const cell=tr.insertCell(); cell.textContent=row[measure]; cell.dataset.size=normalize(row[0]);
          }
        }
        this.tables.append(table);
      }
      source.hidden = true;
      this.tables.hidden = false;
      this.querySelector('.bt-scorecard__units').hidden = false;
      this.querySelector('.bt-scorecard__note').hidden = false;
      this.onClick = event => {
        const unit = event.target.closest('button[data-unit]');
        if (unit) {
          this.querySelectorAll('button[data-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
          this.tables.querySelectorAll('table').forEach(table => table.hidden = table.dataset.unit !== unit.dataset.unit);
        }
        const link = event.target.closest('a[data-variant]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const variant = this.variants.find(item => String(item.id) === link.dataset.variant);
        const native = [...document.querySelectorAll('[id^="ProductInfoWrapper"] input[type="radio"]')].find(input => normalize(input.value) === normalize(variant.size));
        if (native && !native.disabled) {
          event.preventDefault();
          native.click();
          this.selected = String(variant.id);
          this.highlight();
        }
      };
      this.onChange = event => {
        const native = event.target;
        if (!native.matches('[id^="ProductInfoWrapper"] input[type="radio"]')) return;
        const checked = [...document.querySelectorAll('[id^="ProductInfoWrapper"] input[type="radio"]:checked')].map(input => input.value);
        const variant = this.variants.find(item => item.options.every(value => checked.includes(value)));
        if (variant) { this.selected = String(variant.id); this.highlight(); }
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('change', this.onChange);
      this.observer = new IntersectionObserver(entries => {
        document.body.classList.toggle('bt-scorecard-in-view', entries.some(entry => entry.intersectionRatio > 0.12));
      }, {threshold:[0,0.12]});
      this.observer.observe(this);
      this.initialized = true;
      this.highlight();
    }
    matchesOptions(candidate) {
      const current = this.variants.find(item => String(item.id) === this.selected);
      return !current || candidate.options.every((value,index) => index === Number(this.dataset.sizeIndex) || value === current.options[index]);
    }
    highlight() {
      const variant = this.variants.find(item => String(item.id) === this.selected);
      if (!variant) return;
      const images = JSON.parse(this.querySelector('[data-images]').textContent);
      const color = variant.options[Number(this.dataset.colorIndex)]?.toLowerCase();
      const isDetail = image => /collar detail|closeup|close-up/i.test(image.alt);
      const image = (color && images.find(item => item.alt.toLowerCase().includes(color) && isDetail(item))) || images.find(isDetail);
      if (image) {
        const photo = this.querySelector('.bt-scorecard__image img');
        if (photo.getAttribute('src') !== image.src) { photo.src = image.src; photo.removeAttribute('srcset'); }
        photo.alt = image.alt;
        this.querySelector('figcaption span').textContent = image.alt;
      }
      this.querySelectorAll('[data-size]').forEach(cell => cell.classList.toggle('is-selected', cell.dataset.size === this.normalize(variant.size)));
      this.querySelectorAll('thead th[data-size]').forEach(cell => {
        const candidate = this.variants.find(item => this.normalize(item.size) === cell.dataset.size && this.matchesOptions(item));
        const sizeText = cell.textContent.trim();
        cell.replaceChildren();
        cell.classList.toggle('is-unavailable', !candidate?.available);
        if (candidate?.available) {
          cell.removeAttribute('aria-label');
          const link = document.createElement('a'); link.textContent = sizeText; link.href = candidate.url + '#' + this.id; link.dataset.variant = candidate.id;
          cell.append(link);
        } else {
          cell.textContent = sizeText;
          cell.setAttribute('aria-label',sizeText + ' — ' + this.querySelector('[data-sold-out]').dataset.soldOut);
        }
      });
      this.querySelectorAll('[data-variant]').forEach(link => {
        if (link.dataset.variant === this.selected) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      this.querySelector('.bt-scorecard__selection').textContent = variant.available ? this.querySelector('[data-label]').dataset.label.replace('[size]',variant.title) : variant.title + ' — ' + this.querySelector('[data-sold-out]').dataset.soldOut;
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);
      document.removeEventListener('change',this.onChange);
      this.observer?.disconnect();
      document.body.classList.remove('bt-scorecard-in-view');
      this.initialized = false;
      this.tables?.replaceChildren();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-gift-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-gift-finder')){
  customElements.define('bt-gift-finder',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      const init=()=>{
        if(this.ready)return;
        this.ready=true;
        this.cards=[...this.querySelectorAll('[data-gift-price]')].sort((a,b)=>Number(a.dataset.giftPriority)-Number(b.dataset.giftPriority));
        const grid=this.querySelector('.bt-gift__grid');
        this.cards.forEach(card=>grid.append(card));
        this.limit=3;
        this.addEventListener('change',()=>{this.limit=3;this.update();});
        this.querySelector('[data-gift-more]').addEventListener('click',()=>{this.limit+=6;this.update();});
        this.update();
      };
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    }
    update(){
      const budget=Number(this.querySelector('input[type="radio"]:checked').value);
      const sizefree=this.querySelector('[data-gift-sizefree][type="checkbox"]').checked;
      const matches=this.cards.filter(card=>Number(card.dataset.giftPrice)<=budget&&(!sizefree||card.dataset.giftSizefree==='true'));
      this.cards.forEach(card=>{card.hidden=true;});
      matches.slice(0,this.limit).forEach(card=>{card.hidden=false;});
      const count=this.querySelector('[data-gift-count]');
      count.textContent=count.dataset.countTemplate.replace('__shown__',Math.min(this.limit,matches.length)).replace('__total__',matches.length);
      this.querySelector('[data-gift-empty]').hidden=matches.length!==0;
      this.querySelector('[data-gift-more]').hidden=matches.length<=this.limit;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-hat-locker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-hat-locker')) {
  customElements.define('bt-hat-locker',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.panels=Array.from(this.querySelectorAll('[data-hat-panel]'));
      this.choices=Array.from(this.querySelectorAll('[data-hat-choice]'));
      this.querySelector('.bt-hat-locker__lineup').hidden=false;
      this.classList.add('is-ready');
      this.choices.forEach(choice=>choice.addEventListener('click',()=>{
        this.panels.forEach(panel=>panel.toggleAttribute('data-active',panel.dataset.hatPanel===choice.dataset.hatChoice));
        this.choices.forEach(button=>button.setAttribute('aria-pressed',String(button===choice)));
      }));
      this.panels.forEach(panel=>{
        const select=panel.querySelector('select');
        const update=()=>{
          const option=select.selectedOptions[0];
          panel.querySelector('[data-hat-price]').textContent=option.dataset.price;
          const compare=panel.querySelector('[data-hat-compare]');
          compare.hidden=option.dataset.sale!=='true';
          compare.textContent=option.dataset.compare;
          const image=panel.querySelector('.bt-hat-locker__photo img');
          image.removeAttribute('srcset');
          image.src=option.dataset.image;
          panel.querySelector('button[type="submit"]').disabled=option.disabled;
        };
        select.addEventListener('change',update);
        panel.querySelector('form').addEventListener('submit',event=>{
          if(select.selectedOptions[0].disabled){event.preventDefault();return;}
          panel.querySelector('button[type="submit"]').disabled=true;
        });
      });
    }
  });
  window.addEventListener('pageshow',event=>{
    if(event.persisted)document.querySelectorAll('bt-hat-locker select').forEach(select=>select.dispatchEvent(new Event('change')));
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-headcover-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-headcover-shop'))customElements.define('bt-headcover-shop',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.buttons=[...this.querySelectorAll('[data-cover-select]')];
    this.panels=[...this.querySelectorAll('[data-cover-panel]')];
    this.select=id=>{
      if(!this.panels.some(panel=>panel.dataset.coverPanel===id))return;
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.coverSelect===id)));
      this.panels.forEach(panel=>panel.hidden=panel.dataset.coverPanel!==id);
    };
    this.choose=event=>{const button=event.target.closest('[data-cover-select]');if(button)this.select(button.dataset.coverSelect);};
    this.addEventListener('click',this.choose);
    this.querySelector('[data-cover-chooser]').hidden=false;
  }
  disconnectedCallback(){this.removeEventListener('click',this.choose);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-layer-locker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-layer-locker'))customElements.define('bt-layer-locker',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.normalize=value=>({small:'s',medium:'m',large:'l',xxl:'2xl',xxxl:'3xl',xxxxl:'4xl',xxxxxl:'5xl'})[String(value).toLowerCase().trim()]||String(value).toLowerCase().trim();
    this.cards=[...this.querySelectorAll('[data-layer-card]')].map(element=>({element,variants:JSON.parse(element.querySelector('[data-layer-variants]').textContent),color:null}));
    this.size='';this.kind='';
    const params=new URLSearchParams(location.search);const initial=params.get('bt_size');if(['hoodie','sweatshirt'].includes(params.get('bt_kind')))this.kind=params.get('bt_kind');
    const allSizes=new Set(this.cards.flatMap(card=>card.variants.map(v=>this.normalize(v.size))));
    if(initial&&allSizes.has(this.normalize(initial)))this.size=this.normalize(initial);
    this.querySelectorAll('[data-layer-size]').forEach(button=>button.hidden=!!button.dataset.layerSize&&!allSizes.has(this.normalize(button.dataset.layerSize)));
    this.paint=(card,variant)=>{
      const e=card.element;
      e.querySelectorAll('[data-layer-link]').forEach(a=>a.href=variant.url);
      const image=e.querySelector('.bt-layers__photo img');if(image.getAttribute('src')!==variant.image){image.src=variant.image;image.removeAttribute('srcset');}image.alt=variant.alt;
      e.querySelector('[data-layer-price]').textContent=variant.price;
      e.querySelector('[data-layer-choice]').textContent=this.dataset.selected.replace('[option]',variant.title);
      const select=e.querySelector('[data-layer-variant]');
      if(this.size||card.explicit)select.value=String(variant.id);else select.value='';
      e.querySelector('[data-layer-add]').disabled=!select.value;
      e.querySelectorAll('[data-layer-color]').forEach(b=>{
        b.setAttribute('aria-pressed',String(b.dataset.layerColor===variant.color));
        const chosenSize=this.size||(card.explicit?this.normalize(variant.size):'');
        b.disabled=!!chosenSize&&!card.variants.some(v=>v.color===b.dataset.layerColor&&this.normalize(v.size)===chosenSize);
      });
      card.color=variant.color;
    };
    this.update=()=>{
      let count=0;
      this.cards.forEach(card=>{
        const variants=card.variants.filter(v=>!this.size||this.normalize(v.size)===this.size);
        const select=card.element.querySelector('[data-layer-variant]');
        Array.from(select.options).forEach(option=>{if(!option.value)return;const excluded=!!this.size&&this.normalize(option.dataset.size)!==this.size;option.hidden=excluded;option.disabled=excluded;});
        card.element.hidden=!variants.length||!!this.kind&&card.element.dataset.kind!==this.kind;if(card.element.hidden)return;count++;
        const previous=variants.find(v=>String(v.id)===select.value);
        const variant=previous||variants.find(v=>v.color===card.color)||variants[0];
        const colors=card.element.querySelector('[data-layer-colors]');colors.replaceChildren();
        const seen=new Set();variants.forEach(v=>{
          if(!v.color||seen.has(v.color))return;seen.add(v.color);
          const button=document.createElement('button');button.type='button';button.dataset.layerColor=v.color;button.setAttribute('aria-label',v.color);button.title=v.color;
          const img=document.createElement('img');const thumbnail=new URL(v.image,location.href);thumbnail.searchParams.set('width','80');img.src=thumbnail.href;img.alt='';img.width=35;img.height=39;img.loading='lazy';button.append(img);colors.append(button);
        });colors.hidden=seen.size<2;
        this.paint(card,variant);
      });
      this.querySelectorAll('[data-layer-size]').forEach(b=>b.setAttribute('aria-pressed',String(this.normalize(b.dataset.layerSize)===this.size)));
      this.querySelectorAll('[data-layer-kind]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.layerKind===this.kind)));
      this.querySelector('[data-layer-count]').textContent=this.dataset.count.replace('[count]',count).replace('[size]',this.size?this.size.toUpperCase():this.dataset.all)+(this.kind?' · '+this.querySelector('[data-layer-kind="'+this.kind+'"] strong').textContent:'');
      this.querySelector('[data-layer-empty]').hidden=count>0;
    };
    this.click=event=>{
      const size=event.target.closest('[data-layer-size]');const color=event.target.closest('[data-layer-color]');const kind=event.target.closest('[data-layer-kind]');
      if(size||kind||event.target.closest('[data-layer-reset]')){
        if(size)this.size=this.normalize(size.dataset.layerSize);else if(kind)this.kind=kind.dataset.layerKind;else{this.size='';this.kind='';}
        if(size||event.target.closest('[data-layer-reset]'))this.cards.forEach(card=>{card.explicit=false;card.element.querySelector('[data-layer-variant]').value=''});
        this.update();
        const url=new URL(location.href);if(this.size)url.searchParams.set('bt_size',this.size.toUpperCase());else url.searchParams.delete('bt_size');if(this.kind)url.searchParams.set('bt_kind',this.kind);else url.searchParams.delete('bt_kind');history.replaceState(null,'',url);
      }else if(color){
        const card=this.cards.find(c=>c.element===color.closest('[data-layer-card]'));
        const selected=card.variants.find(v=>String(v.id)===card.element.querySelector('[data-layer-variant]').value);
        const activeSize=this.size||(selected?this.normalize(selected.size):'');
        const variant=card.variants.find(v=>v.color===color.dataset.layerColor&&(!activeSize||this.normalize(v.size)===activeSize));if(variant)this.paint(card,variant);
      }
    };
    this.change=event=>{
      if(!event.target.matches('[data-layer-variant]'))return;
      const card=this.cards.find(c=>c.element===event.target.closest('[data-layer-card]'));
      const variant=card.variants.find(v=>String(v.id)===event.target.value);
      card.explicit=!!variant;
      if(variant)this.paint(card,variant);else{card.element.querySelector('[data-layer-add]').disabled=true;card.element.querySelectorAll('[data-layer-color]').forEach(b=>b.disabled=false);}
    };
    this.addEventListener('change',this.change);
    this.addEventListener('click',this.click);this.querySelector('[data-layer-filters]').hidden=false;this.querySelector('[data-layer-types]').hidden=false;this.update();
  }
  disconnectedCallback(){this.removeEventListener('click',this.click);this.removeEventListener('change',this.change);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-pro-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-pro-shop'))customElements.define('bt-pro-shop',class extends HTMLElement{
connectedCallback(){
 this.pageSize=window.matchMedia('(max-width:749px)').matches?4:8;
 this.size='';this.limit=this.pageSize;this.busy=false;this.selected=new Map();this.needsReview=false;this.restoreComplete=false;
 this.storageKey='bt-pro-rotation-v1-'+this.dataset.themeId+'-'+this.id;
 this.querySelector('[data-review-picks]').addEventListener('click',()=>{
  const button=this.querySelector('[data-review-picks]');
  const open=button.getAttribute('aria-expanded')!=='true';
  button.setAttribute('aria-expanded',String(open));
  this.querySelector('[data-review-tray]').hidden=!open;
 });
 this.querySelector('[data-review-list]').addEventListener('click',event=>{
  const button=event.target.closest('[data-remove-pick]');if(!button||this.busy)return;
  this.selected.delete(button.dataset.removePick);this.syncSelection();
  if(this.selected.size)this.querySelector('[data-review-picks]').focus();
 });
 this.tabs=Array.from(this.querySelectorAll('[data-tab]'));this.panels=Array.from(this.querySelectorAll('[data-panel]'));
 this.cards=Array.from(this.querySelectorAll('[data-pro-card]'));
 this.cards.forEach(card=>{card.variants=JSON.parse(card.querySelector('[data-pro-variants]').textContent);card.querySelector('.bt-pro__check-label').hidden=false;});
 this.inView=false;
 this.visibilityObserver=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.syncSelection();},{rootMargin:'-80px 0px -80px 0px'});
 this.visibilityObserver.observe(this);
 this.querySelector('[data-clear]').addEventListener('click',()=>{this.selected.clear();this.syncSelection();});
 this.querySelector('[data-add-selected]').addEventListener('click',()=>this.addSelected());
 this.querySelector('[data-tabs]').setAttribute('role','tablist');
 this.tabs.forEach((tab,index)=>{
  tab.setAttribute('role','tab');tab.id=this.id+'-tab-'+index;tab.setAttribute('aria-controls',tab.hash.slice(1));
  const panel=this.panels.find(panel=>panel.dataset.panel===tab.dataset.tab);
  panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);
  tab.addEventListener('click',event=>{event.preventDefault();this.activate(tab);});
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
   else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
   else if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;else return;
   event.preventDefault();this.activate(this.tabs[next]);this.tabs[next].focus();
  });
 });
 this.querySelectorAll('[data-size]').forEach(button=>button.addEventListener('click',()=>{
  this.size=button.dataset.size;this.limit=this.pageSize;this.selected.clear();
  this.querySelectorAll('[data-size]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  this.update();
 }));
 this.querySelectorAll('[data-more]').forEach(button=>button.addEventListener('click',()=>{this.limit+=this.pageSize;this.update();}));
 this.querySelectorAll('[data-reset-size]').forEach(button=>button.addEventListener('click',()=>this.querySelector('[data-size=""]').click()));
 this.addEventListener('change',event=>{
  const card=event.target.closest('[data-pro-card]');if(!card)return;
  const select=card.querySelector('select');
  const variant=card.variants.find(v=>String(v.id)===select.value);
  if(event.target.matches('[data-pick]')){
   if(event.target.checked){if(!variant){event.target.checked=false;select.reportValidity();select.focus();return;}this.selected.set(card.dataset.productId,{variant,title:card.querySelector('h3').textContent.trim(),option:select.selectedOptions[0].textContent.split(' — ')[0]});}
   else this.selected.delete(card.dataset.productId);
  }else if(event.target===select){
   if(variant){this.paint(card,variant);if(this.selected.has(card.dataset.productId))this.selected.set(card.dataset.productId,{variant,title:card.querySelector('h3').textContent.trim(),option:select.selectedOptions[0].textContent.split(' — ')[0]});}
   else this.selected.delete(card.dataset.productId);
  }
  this.syncSelection();
 });
 this.classList.add('bt-pro--ready');
 const savedTab=this.restoreRotation();
 this.restoreComplete=true;
 if(this.tabs.length)this.activate(this.tabs.find(tab=>tab.dataset.tab===savedTab)||this.tabs[0]);
}
disconnectedCallback(){this.visibilityObserver?.disconnect();}
restoreRotation(){
 let saved;try{saved=JSON.parse(sessionStorage.getItem(this.storageKey)||'null');}catch{return '';}
 if(!saved||!Array.isArray(saved.picks))return '';
 const size=typeof saved.size==='string'?saved.size:'';
 if(Array.from(this.querySelectorAll('[data-size]')).some(button=>button.dataset.size===size))this.size=size;
 let removed=0;
 saved.picks.slice(0,50).forEach(pick=>{
  const card=this.cards.find(card=>card.dataset.productId===String(pick.productId));if(!card){removed++;return;}
  const index=Number(card.dataset.sizeIndex);
  const variant=card.variants.find(variant=>String(variant.id)===String(pick.variantId)&&variant.available&&(!this.size||index<0||this.normalize(variant.options[index])===this.normalize(this.size)));
  const option=variant&&Array.from(card.querySelector('select').options).find(option=>option.value===String(variant.id));
  if(!variant||!option){removed++;return;}
  this.selected.set(card.dataset.productId,{variant,title:card.querySelector('h3').textContent.trim(),option:option.textContent.split(' — ')[0]});
 });
 this.querySelectorAll('[data-size]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.size===this.size)));
 if(this.selected.size){
  this.querySelector('[data-review-picks]').setAttribute('aria-expanded','true');
  this.querySelector('[data-review-tray]').hidden=false;
 }
 if(removed||this.selected.size)this.querySelector('[data-feedback]').textContent=removed?this.dataset.unavailablePicks:this.dataset.restored;
 return typeof saved.tab==='string'?saved.tab:'';
}
saveRotation(){
 if(!this.restoreComplete)return;
 const data=JSON.stringify({size:this.size,tab:this.active?.dataset.tab||'',picks:Array.from(this.selected.entries()).map(([productId,item])=>({productId,variantId:item.variant.id}))});
 if(data===this.lastSavedState)return;
 try{sessionStorage.setItem(this.storageKey,data);this.lastSavedState=data;}catch{}
}
renderReview(){
 const list=this.querySelector('[data-review-list]');
 const fragment=document.createDocumentFragment();
 this.selected.forEach((item,productId)=>{
  const card=this.cards.find(card=>card.dataset.productId===productId);if(!card)return;
  const row=document.createElement('article');row.className='bt-pro__review-card';
  const link=document.createElement('a');link.href=card.dataset.url+'?variant='+item.variant.id;link.className='bt-pro__review-photo';link.setAttribute('aria-label',item.title);
  const image=document.createElement('img');image.src=item.variant.image||card.querySelector('img').currentSrc||card.querySelector('img').src;image.alt='';image.width=64;image.height=76;link.append(image);
  const text=document.createElement('div');text.className='bt-pro__review-info';
  const title=document.createElement('a');title.href=link.href;title.textContent=item.title;
  const option=document.createElement('p');option.textContent=item.option;
  const price=document.createElement('strong');price.textContent=item.variant.price;
  text.append(title,option,price);
  const remove=document.createElement('button');remove.type='button';remove.dataset.removePick=productId;remove.textContent='×';remove.disabled=this.busy;remove.setAttribute('aria-label',this.dataset.removeLabel.replace('[product]',item.title));
  row.append(link,text,remove);fragment.append(row);
 });
 list.replaceChildren(fragment);
 if(!this.selected.size){
  this.querySelector('[data-review-tray]').hidden=true;
  this.querySelector('[data-review-picks]').setAttribute('aria-expanded','false');
 }
}
normalize(value){const key=String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');return({small:'s',medium:'m',large:'l',xlarge:'xl',extralarge:'xl',xxl:'2xl',xxlarge:'2xl',xxxlarge:'3xl',xxxl:'3xl',xxxxl:'4xl',xxxxlarge:'4xl',xxxxxl:'5xl',xxxxxlarge:'5xl',extrasmall:'xs',xsmall:'xs'})[key]||key;}
activate(tab){
 this.active=tab;this.limit=this.pageSize;
 const help=this.querySelector('[data-polo-help]');help.hidden=tab.dataset.isPolo!=='true';if(help.hidden)help.open=false;
 this.tabs.forEach(item=>{item.setAttribute('aria-selected',String(item===tab));item.tabIndex=item===tab?0:-1;});
 this.panels.forEach(panel=>panel.hidden=panel.dataset.panel!==tab.dataset.tab);
 const panel=this.panels.find(item=>item.dataset.panel===tab.dataset.tab);
 const hasSizes=Array.from(panel.querySelectorAll('[data-pro-card]')).some(card=>Number(card.dataset.sizeIndex)>=0);
 this.querySelector('.bt-pro__sizes').hidden=!hasSizes;
 const availableSizes=new Set();
 panel.querySelectorAll('[data-pro-card]').forEach(card=>{const index=Number(card.dataset.sizeIndex);if(index>=0)card.variants.forEach(variant=>{if(variant.available)availableSizes.add(this.normalize(variant.options[index]));});});
 this.querySelectorAll('[data-size]').forEach(button=>{button.hidden=!!button.dataset.size&&button.dataset.size!==this.size&&!availableSizes.has(this.normalize(button.dataset.size));});
 this.update();
 const bar=this.querySelector('.bt-pro__shopbar');
 if(bar.getBoundingClientRect().top<=1)bar.scrollIntoView({block:'start',behavior:'instant'});
 const rail=this.querySelector('[data-tabs]');rail.scrollTo({left:Math.max(0,tab.offsetLeft-rail.offsetLeft-12),behavior:'instant'});
}
paint(card,variant){
 card.querySelector('[data-price]').textContent=variant.price;
 const compare=card.querySelector('[data-compare]');compare.hidden=!variant.sale;compare.textContent=variant.compare;
 const sale=card.querySelector('.bt-pro__sale');if(sale)sale.hidden=!variant.sale;
 card.querySelectorAll('[data-product-link]').forEach(link=>link.href=card.dataset.url+'?variant='+variant.id);
 if(variant.image){
  const image=card.querySelector('.bt-pro__photo img');
  if(image.dataset.variantImage!==variant.image){
   const source=new URL(variant.image,document.baseURI);
   image.srcset=[200,300,450,600].map(width=>{const url=new URL(source);url.searchParams.set('width',width);return url.href+' '+width+'w';}).join(', ');
   image.sizes='(max-width: 749px) calc(50vw - 42px), (max-width: 1488px) calc(25vw - 38px), 327px';
   image.src=source.href;
   image.dataset.variantImage=variant.image;
  }
 }
}
update(){
 const panel=this.panels.find(item=>item.dataset.panel===this.active.dataset.tab);if(!panel)return;
 const panelCards=Array.from(panel.querySelectorAll('[data-pro-card]'));
 const filter=panelCards.some(card=>Number(card.dataset.sizeIndex)>=0)?this.size:'';
 const filterValues=new Set();let count=0;
 panel.querySelectorAll('[data-pro-card]').forEach(card=>{
  const sizeIndex=Number(card.dataset.sizeIndex);
  const options=card.variants.filter(v=>v.available&&(!filter||sizeIndex<0||this.normalize(v.options[sizeIndex])===this.normalize(filter)));
  if(filter&&sizeIndex>=0)options.forEach(variant=>filterValues.add(variant.options[sizeIndex]));
  card.hidden=!options.length;
  if(!options.length){this.selected.delete(card.dataset.productId);return;}
  count++;if(count>this.limit)card.hidden=true;
  const select=card.querySelector('select');
  Array.from(select.options).forEach(option=>{if(!option.value)return;const eligible=options.some(v=>String(v.id)===option.value);option.hidden=!eligible;option.disabled=!eligible;});
  const selection=this.selected.get(card.dataset.productId);
  const current=options.find(v=>String(v.id)===(selection?String(selection.variant.id):select.value));
  const variant=current||((filter||options.length===1)?options[0]:null);
  select.value=variant?String(variant.id):'';
  this.paint(card,variant||options[0]);
 });
 this.querySelector('[data-result]').textContent=(panel.dataset.clubShop==='true'?this.dataset.clubResults:this.dataset.results).replace('[count]',String(count))+(filter?' · '+filter:'');
 panel.querySelector('[data-more]').hidden=count<=this.limit;
 panel.querySelector('.bt-pro__empty').hidden=count!==0;
 const browse=panel.querySelector('[data-browse-link]');
 browse.textContent=(panel.dataset.clubShop==='true'?this.dataset.clubBrowse:this.dataset.browse.replace('[category]',panel.dataset.label)+(filter?' · '+filter:''))+' →';
 const url=new URL(panel.dataset.collectionUrl,location.origin);
 if(filter){
  filterValues.forEach(value=>url.searchParams.append('filter.v.option.size',value));
  url.searchParams.set('filter.v.availability','1');
  url.searchParams.set('bt_size',filter);
 }
 browse.hidden=!!filter&&!count;
 browse.href=url.href;
 this.tabs.forEach(tab=>{
  const rack=this.panels.find(item=>item.dataset.panel===tab.dataset.tab);
  const matches=Array.from(rack.querySelectorAll('[data-pro-card]')).filter(card=>{
   const index=Number(card.dataset.sizeIndex);
   return card.variants.some(variant=>variant.available&&(!this.size||index<0||this.normalize(variant.options[index])===this.normalize(this.size)));
  }).length;
  tab.querySelector('small').textContent=String(matches);
 });
 this.syncSelection();
}
syncSelection(){
 this.cards.forEach(card=>{
  const selection=this.selected.get(card.dataset.productId);
  card.querySelector('[data-pick]').checked=!!selection;
  if(selection){const select=card.querySelector('select');select.value=String(selection.variant.id);this.paint(card,selection.variant);}
 });
 const count=this.selected.size;
 this.querySelector('[data-basket]').hidden=!count||!this.inView;
 this.querySelector('[data-selection-count]').textContent=this.dataset.selected.replace('[count]',String(count));
 this.querySelector('[data-selection-names]').textContent=Array.from(this.selected.values()).map(item=>item.title+' · '+item.option).join(' / ');
 const total=Array.from(this.selected.values()).reduce((sum,item)=>sum+item.variant.rawPrice,0);
 this.querySelector('[data-selection-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency}).format(total/100);
 this.querySelector('[data-add-selected-label]').textContent=count===1?this.dataset.addOne:this.dataset.addMany.replace('[count]',String(count));
 this.querySelector('[data-add-selected]').disabled=!count||this.busy||this.needsReview;
 this.querySelector('[data-clear]').disabled=!count||this.busy;
 this.querySelector('[data-review-picks]').disabled=this.busy;
 this.renderReview();this.saveRotation();
 this.querySelectorAll('[data-pick],.bt-pro__form select,[data-size],[data-tab],[data-more]').forEach(control=>{if('disabled' in control)control.disabled=this.busy;});
}
async addSelected(){
 if(this.busy||this.needsReview||!this.selected.size)return;
 this.busy=true;this.syncSelection();
 const feedback=this.querySelector('[data-feedback]');feedback.textContent='';
 const selected=Array.from(this.selected.values());
 try{
  const drawer=document.getElementById('CartDrawer');
  const sectionIds=[];if(drawer?.dataset.sectionId)sectionIds.push(drawer.dataset.sectionId);
  const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:selected.map(item=>({id:item.variant.id,quantity:1})),sections:sectionIds,sections_url:location.pathname})});
  const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);
  if(!Array.isArray(result.items))throw new Error(this.dataset.error);
  feedback.textContent=this.dataset.batchAdded.replace('[count]',String(result.items.length));
  this.selected.clear();this.querySelector('[data-added-link]').hidden=false;
  try{
   const parsedState=result.items[0];
   if(!drawer?.purchaseHandler||!result.sections?.[drawer.dataset.sectionId]){window.location.assign(this.dataset.cartUrl);return;}
   try{
    await drawer.purchaseHandler(new DOMParser().parseFromString(result.sections[drawer.dataset.sectionId],'text/html'),parsedState);
   }catch{window.location.assign(this.dataset.cartUrl);return;}
   const cartResponse=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});
   if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('cart-count').forEach(target=>{const badge=document.createElement('div');badge.className='cart-count';if(cart.item_count>9)badge.classList.add('cart-count--ellipse');const span=document.createElement('span');span.setAttribute('aria-hidden','true');span.textContent=cart.item_count;badge.append(span);target.replaceChildren(...(cart.item_count?[badge]:[]));});}
  }catch{}
 }catch(error){this.needsReview=true;feedback.textContent=this.dataset.review;this.querySelector('[data-added-link]').hidden=false;}
 finally{this.busy=false;this.syncSelection();}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-product-story'))customElements.define('bt-product-story',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const content=this.querySelector('[data-story-description]');
  const children=Array.from(content.childNodes);
  const heading=node=>node.nodeType===1&&/^H[2-4]$/.test(node.tagName);
  if(children.filter(heading).length<2)return;
  let headingCount=0,current=null;
  const result=document.createDocumentFragment();
  children.forEach(node=>{
   if(heading(node)){
    headingCount++;
    if(headingCount===1){
     const title=document.createElement('h3');title.textContent=node.textContent;
     result.append(title);return;
    }
    const details=document.createElement('details');
    const summary=document.createElement('summary');summary.textContent=node.textContent;
    current=document.createElement('div');current.className='bt-story__details-body';
    details.append(summary,current);result.append(details);
   }else if(current)current.append(node);
   else result.append(node);
  });
  content.replaceChildren(result);
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-recent-shelf"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-recent-shelf'))customElements.define('bt-recent-shelf',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();
  this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'400px'});
  this.observer.observe(this.parentElement);
 }
 disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
 async load(){
  let history;try{history=JSON.parse(localStorage.getItem('AuroraTheme-RecentlyViewed')||'[]');}catch{return;}
  if(!Array.isArray(history))return;
  const handles=Array.from(new Set(history.filter(handle=>typeof handle==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(handle)))).slice(0,4);
  if(!handles.length)return;
  const cards=await Promise.all(handles.map(async handle=>{
   try{
    const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(handle)+'?section_id=bt-recent-card',{signal:this.controller.signal});
    if(!response.ok)return null;
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    return html.querySelector('[data-recent-card]');
   }catch{return null;}
  }));
  if(!this.isConnected)return;
  const available=cards.filter(Boolean);
  if(!available.length)return;
  this.querySelector('[data-recent-cards]').replaceChildren(...available);
  this.hidden=false;
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-review-spotlight"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-review-spotlight'))customElements.define('bt-review-spotlight',class extends HTMLElement{
connectedCallback(){
  this.querySelector('[data-back]')?.addEventListener('click',event=>{
    const target=document.querySelector('[id^="ProductInfoWrapper-"]');
    if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});}
  });
  const render=()=>{
    const widget=document.getElementById('judgeme_product_reviews');
    const reviews=Array.from(widget?.querySelectorAll('.jdgm-rev')||[]).filter(review=>review.querySelector('.jdgm-rev__body')?.textContent.trim()).slice(0,3);
    const badge=document.querySelector('.jdgm-prev-badge[data-average-rating]');
    const average=Number(badge?.dataset.averageRating);
    const count=Number(badge?.dataset.numberOfReviews);
    if(!reviews.length||!count||!Number.isFinite(average))return false;
    const cards=this.querySelector('[data-reviews]');
    cards.replaceChildren();
    reviews.forEach(review=>{
      const article=document.createElement('article');article.className='bt-word__card';
      const stars=document.createElement('div');stars.className='bt-word__stars';
      const score=Math.max(0,Math.min(5,Number(review.querySelector('.jdgm-rev__rating')?.dataset.score)||0));
      stars.textContent='★'.repeat(score)+'☆'.repeat(5-score);stars.setAttribute('aria-label',this.dataset.ratingLabel.replace('[rating]',String(score)));
      const title=document.createElement('h3');title.textContent=review.querySelector('.jdgm-rev__title')?.textContent.trim()||'';
      const quote=document.createElement('blockquote');
      const body=review.querySelector('.jdgm-rev__body').cloneNode(true);body.querySelectorAll('.jdgm-rev__read-more,.jdgm-rev__read-less').forEach(node=>node.remove());
      const text=body.textContent.trim().replace(/Read more\s*$/i,'').trim();quote.textContent=text.length>250?text.slice(0,247).trimEnd()+'…':text;
      const author=document.createElement('div');author.className='bt-word__author';author.textContent=review.querySelector('.jdgm-rev__author')?.textContent.trim()||this.dataset.anonymous;
      article.append(stars,title,quote,author);cards.append(article);
    });
    this.querySelector('[data-rating]').textContent=average.toFixed(1)+' / 5';
    this.querySelector('[data-count]').textContent=this.dataset.countLabel.replace('[count]',String(count));
    this.hidden=false;return true;
  };
  if(render())return;
  this.observer=new MutationObserver(()=>{if(render()){this.observer.disconnect();clearTimeout(this.timeout);}});
  this.observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
  this.timeout=setTimeout(()=>this.observer.disconnect(),20000);
}
disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.timeout);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-reviews-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-reviews-hub'))customElements.define('bt-reviews-hub',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.products=JSON.parse(this.querySelector('[data-review-products]').textContent);
    const path=value=>{try{return new URL(value,location.origin).pathname.replace(/\/$/,'');}catch{return '';}};
    const render=()=>{
      const summary=document.querySelector('.jdgm-all-reviews-text__text[data-score]');
      const score=Number(summary?.dataset.score),count=Number(summary?.dataset.numberOfReviews);
      if(score>0&&score<=5&&count>0&&this.ratingKey!==score+'|'+count){this.ratingKey=score+'|'+count;this.querySelector('[data-review-score]').textContent=this.dataset.ratingTemplate.replace('__score__',score);this.querySelector('[data-review-count]').textContent=this.dataset.countTemplate.replace('__count__',count);this.querySelector('[data-review-overview]').hidden=false;this.dataset.ratingReady='true';}
      if(!this.highlightsReady){
        const selected=[],used=new Set();
        document.querySelectorAll('.jdgm-all-reviews-widget .jdgm-rev').forEach(review=>{
          if(selected.length>=3)return;
          const href=review.querySelector('.jdgm-rev__prod-link')?.getAttribute('href');
          const product=this.products.find(item=>path(item.url)===path(href));
          const quote=[...review.querySelectorAll('.jdgm-rev__body p')].map(p=>p.textContent.trim()).filter(Boolean).join('\n\n');
          const rating=Number(review.querySelector('.jdgm-rev__rating')?.dataset.score);
          if(!product||used.has(product.url)||!quote||rating<1||rating>5||!Number.isInteger(rating))return;
          used.add(product.url);selected.push({product,quote,rating,author:review.querySelector('.jdgm-rev__author')?.textContent.trim()||'',date:review.querySelector('.jdgm-rev__timestamp')?.textContent.trim()||''});
        });
        const highlightsKey=JSON.stringify(selected);
        if(selected.length&&this.highlightsKey!==highlightsKey){
          this.highlightsKey=highlightsKey;
          [...this.querySelectorAll('[data-review-card]')].forEach((card,index)=>{
            const item=selected[index];if(!item)return;
            card.querySelectorAll('[data-review-link]').forEach(link=>link.href=item.product.url);
            const image=card.querySelector('[data-review-image]');image.src=item.product.image;image.alt=item.product.title;
            const stars=card.querySelector('[data-review-stars]');stars.textContent='★'.repeat(item.rating)+'☆'.repeat(5-item.rating);stars.setAttribute('aria-label',this.dataset.starsTemplate.replace('__score__',item.rating));
            card.querySelector('[data-review-quote]').textContent='“'+item.quote+'”';card.querySelector('[data-review-author]').textContent=item.author;card.querySelector('[data-review-date]').textContent=item.date;card.querySelector('[data-review-title]').textContent=item.product.title;card.querySelector('[data-review-price]').textContent=item.product.price;card.hidden=false;
          });
          this.querySelector('[data-review-highlights]').hidden=false;
          if(selected.length===3)this.highlightsReady=true;
        }
      }
      return this.highlightsReady&&this.dataset.ratingReady;
    };
    if(render())return;
    this.observer=new MutationObserver(()=>{if(render()){this.observer.disconnect();clearTimeout(this.timeout);}});
    this.observer.observe(document.body,{childList:true,subtree:true});this.timeout=setTimeout(()=>this.observer.disconnect(),25000);
  }
  disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.timeout);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-round-kit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-round-kit')) {
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('bt-round-kit details[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  customElements.define('bt-round-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.polo = this.querySelector('[name="polo"]');
      this.hat = this.querySelector('[name="hat"]');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.buttonLabel = this.button.querySelector('span').textContent;
      this.prompt = this.status.textContent;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency', currency:this.dataset.currency});
      this.form.hidden = false;
      this.variantOptions = {
        polo: Array.from(this.polo.options).map(option => option.cloneNode(true)),
        hat: Array.from(this.hat.options).map(option => option.cloneNode(true))
      };
      for (const select of [this.polo,this.hat]) {
        select.replaceChildren(select.options[0].cloneNode(true));
        select.disabled = true;
      }
      this.form.addEventListener('change', event => {
        if (event.target.matches('.bt-kit__product-radio')) this.chooseProduct(event.target);
        this.updateKit();
      });
      this.form.addEventListener('submit', event => this.addKit(event));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const dropdown = event.target.closest('details');
          if (dropdown) {
            dropdown.open = false;
            dropdown.querySelector('summary').focus();
          }
        }
      });
      if(this.classList.contains('bt-kit--product')){
        this.visibilityObserver=new IntersectionObserver(entries=>{
          document.body.classList.toggle('bt-outfit-in-view',entries[0].intersectionRatio>0.15);
        },{threshold:[0,0.15]});
        this.visibilityObserver.observe(this);
        const input=this.querySelector('[name="polo_product"]');
        if(input){
          input.checked=true;
          this.chooseProduct(input,false);
          const variant=this.dataset.initialVariant;
          if(variant&&Array.from(this.polo.options).some(option=>option.value===variant&&!option.disabled))this.polo.value=variant;
        }
      }
      if(this.classList.contains('bt-kit--home')){
        for(const kind of ['polo','hat']){
          const input=this.querySelector('[name="'+kind+'_product"]');
          if(input){input.checked=true;this.chooseProduct(input,false);}
        }
      }
      this.updateKit();
    }
    disconnectedCallback(){
      this.visibilityObserver?.disconnect();
      if(this.classList.contains('bt-kit--product'))document.body.classList.remove('bt-outfit-in-view');
    }
    chooseProduct(input,focus=true) {
      const kind = input.dataset.kind;
      const dropdown = input.closest('details');
      const label = this.querySelector('label[for="' + input.id + '"]');
      const selected = dropdown.querySelector('.bt-kit__selected');
      selected.replaceChildren(...Array.from(label.children).map(child => child.cloneNode(true)));
      dropdown.open = false;
      if(focus)dropdown.querySelector('summary').focus();
      const select = this[kind];
      const options = this.variantOptions[kind];
      const productOptions = options.filter(option => option.dataset.product === input.value);
      select.replaceChildren(options[0].cloneNode(true), ...productOptions.map(option => option.cloneNode(true)));
      const available = productOptions.filter(option => !option.disabled);
      select.disabled = available.length === 0;
      if (available.length === 1) select.value = available[0].value;
      this.querySelector('[data-' + kind + '-title]').textContent = input.dataset.title;
      this.querySelector('[data-' + kind + '-price]').textContent = this.money.format(Number(input.dataset.price) / 100);
      const template = this.querySelector('[data-kit-preview="' + input.dataset.preview + '"]');
      if (template) this.paintPreview(kind,template);
    }
    paintPreview(kind,template) {
      const preview=this.querySelector('[data-'+kind+'-preview]');
      if(preview.dataset.currentPreview===template.dataset.kitPreview)return;
      preview.replaceChildren(template.content.cloneNode(true));
      preview.dataset.currentPreview=template.dataset.kitPreview;
    }
    updateKit() {
      let total = 0;
      for (const [kind, select] of [['polo',this.polo],['hat',this.hat]]) {
        const option = select.selectedOptions[0];
        if (!option.value) continue;
        total += Number(option.dataset.price);
        this.querySelector('[data-' + kind + '-title]').textContent = option.dataset.title;
        this.querySelector('[data-' + kind + '-price]').textContent = this.money.format(Number(option.dataset.price) / 100);
        const template = this.querySelector('[data-kit-preview="' + option.dataset.preview + '"]');
        if (template) this.querySelector('[data-' + kind + '-preview]').replaceChildren(template.content.cloneNode(true));
      }
      const readyCount=this.querySelector('[data-kit-ready]');
      if(readyCount)readyCount.textContent=readyCount.dataset.format.replace('[count]',Number(Boolean(this.polo.value))+Number(Boolean(this.hat.value)));
      const valid = Boolean(this.polo.value && this.hat.value);
      this.querySelector('[data-kit-total]').textContent = valid ? this.money.format(total / 100) : '—';
      this.button.disabled = !valid || this.busy || this.needsReview;
      if (!this.needsReview && !this.busy) this.status.textContent = valid ? '' : this.prompt;
    }
    async addKit(event) {
      event.preventDefault();
      if (this.busy || this.needsReview || !this.form.reportValidity()) return;
      this.busy = true;
      this.button.disabled = true;
      this.polo.disabled = true;
      this.hat.disabled = true;
      this.querySelectorAll('fieldset').forEach(group => group.disabled = true);
      this.form.setAttribute('aria-busy','true');
      this.button.querySelector('span').textContent = this.dataset.adding;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(this.polo.value),quantity:1},{id:Number(this.hat.value),quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== 2) throw new Error('kit-add-failed');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.needsReview = true;
        this.status.textContent = this.dataset.error;
        this.querySelector('.bt-kit__review').hidden = false;
        this.button.querySelector('span').textContent = this.buttonLabel;
      } finally {
        this.busy = !this.needsReview;
        this.form.removeAttribute('aria-busy');
        this.polo.disabled = false;
        this.hat.disabled = false;
        this.querySelectorAll('fieldset').forEach(group => group.disabled = false);
        this.updateKit();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-sale-rack"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-sale-rack')) customElements.define('bt-sale-rack',class extends HTMLElement {
  connectedCallback(){
    if(this.ready)return; this.ready=true;
    this.normalize=value=>({small:'s',medium:'m',large:'l',xxl:'2xl',xxxl:'3xl'})[String(value).trim().toLowerCase()]||String(value).trim().toLowerCase();
    this.cards=[...this.querySelectorAll('[data-sale-card]')].map(element=>({element,variants:JSON.parse(element.querySelector('[data-sale-variants]').textContent)}));
    this.paint=(element,variant)=>{
      element.querySelectorAll('[data-sale-link]').forEach(link=>link.href=variant.url);
      element.querySelector('[data-sale-price]').textContent=variant.price;
      element.querySelector('[data-sale-compare]').textContent=variant.compare;
      element.querySelector('[data-sale-saving]').textContent=this.dataset.save.replace('[amount]',variant.saving);
      element.querySelector('[data-sale-percent]').textContent='−'+variant.percent+'%';
      const image=element.querySelector('img');
      if(image.getAttribute('src')!==variant.image){image.src=variant.image;image.removeAttribute('srcset');}
    };
    this.change=event=>{
      const select=event.target.closest('.bt-sale__quick-form select');if(!select)return;
      const card=this.cards.find(card=>card.element.contains(select));
      const variant=card.variants.find(v=>String(v.id)===select.value);
      card.element.querySelector('button[type="submit"]').disabled=!variant;
      if(variant)this.paint(card.element,variant);
    };
    this.submit=event=>{
      const form=event.target.closest('.bt-sale__quick-form');if(!form)return;
      const select=form.querySelector('select');
      if(!select.value||select.selectedOptions[0].disabled){event.preventDefault();select.reportValidity();return;}
      form.querySelector('button').disabled=true;
    };
    this.restore=()=>this.querySelectorAll('.bt-sale__quick-form button').forEach(button=>{const select=button.closest('form').querySelector('select');button.disabled=!select.value||select.selectedOptions[0].disabled});
    this.addEventListener('change',this.change);this.addEventListener('submit',this.submit);window.addEventListener('pageshow',this.restore);
    this.category='all'; this.size='';
    const params=new URLSearchParams(location.search);
    const initial=params.get('bt_size')||params.get('filter.v.option.size')||'';
    if(['xs','s','m','l','xl','2xl','3xl'].includes(this.normalize(initial))){this.size=this.normalize(initial);this.category='polos';}
    this.update=()=>{
      let count=0;
      this.cards.forEach(({element,variants})=>{
        const variant=variants.find(v=>!this.size||this.normalize(v.size)===this.size);
        const show=(this.category==='all'||element.dataset.category===this.category)&&!!variant&&(!this.size||element.dataset.category==='polos');
        element.hidden=!show;
        if(!show)return; count++;
        const select=element.querySelector('select[name="id"]');
        const current=variants.find(v=>String(v.id)===select.value);
        const selected=this.size?variant:current;
        Array.from(select.options).forEach(option=>{
          if(!option.value)return;
          const match=variants.find(v=>String(v.id)===option.value);
          option.disabled=!!this.size&&this.normalize(match.size)!==this.size;
          option.hidden=option.disabled;
        });
        select.value=selected?String(selected.id):'';
        this.paint(element,selected||variant);
        element.querySelector('button[type="submit"]').disabled=!selected;

      });
      this.querySelectorAll('[data-sale-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.saleCategory===this.category)));
      this.querySelectorAll('[data-sale-size]').forEach(b=>b.setAttribute('aria-pressed',String(this.normalize(b.dataset.saleSize)===this.size)));
      this.querySelector('[data-sale-sizes]').hidden=this.category==='hats';
      this.querySelector('[data-sale-count]').textContent=this.dataset.count.replace('[count]',count).replace('[size]',this.size?this.size.toUpperCase():this.dataset.all);
      this.querySelector('[data-sale-empty]').hidden=count>0;
      const browse=this.querySelector('[data-sale-browse]');
      const url=new URL(browse.href);url.searchParams.set('filter.v.availability','1');
      if(this.size)url.searchParams.set('filter.v.option.size',({s:'Small',m:'Medium',l:'Large'})[this.size]||this.size.toUpperCase());else url.searchParams.delete('filter.v.option.size');
      browse.href=url.href;
    };
    this.click=event=>{
      const category=event.target.closest('[data-sale-category]');
      const size=event.target.closest('[data-sale-size]');
      if(category){this.category=category.dataset.saleCategory;this.size='';}
      else if(size){this.size=this.normalize(size.dataset.saleSize);if(this.size)this.category='polos';}
      else if(event.target.closest('[data-sale-reset]')){this.category='all';this.size='';}
      else return;
      this.update();
      const url=new URL(location.href);url.searchParams.delete('filter.v.option.size');url.searchParams.delete('page');
      if(this.size)url.searchParams.set('bt_size',this.size.toUpperCase());else url.searchParams.delete('bt_size');
      history.replaceState(null,'',url);
    };
    this.addEventListener('click',this.click);
    this.querySelector('[data-sale-tools]').hidden=false; this.update();
  }
  disconnectedCallback(){this.removeEventListener('click',this.click);this.removeEventListener('change',this.change);this.removeEventListener('submit',this.submit);window.removeEventListener('pageshow',this.restore);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-size-alternatives"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-size-alternatives')) {
  customElements.define('bt-size-alternatives', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.normalize = value => ({small:'s',medium:'m',large:'l',xxl:'2xl',xxxl:'3xl'})[String(value).toLowerCase().trim()] || String(value).toLowerCase().trim();
      this.cards = [...this.querySelectorAll('article')].map(element => ({element,variants:JSON.parse(element.querySelector('[data-card-variants]').textContent)}));
      this.currentVariants = JSON.parse(this.querySelector('[data-current-variants]').textContent);
      this.offset = 0;
      this.callout = document.createElement('aside');
      this.callout.className = 'bt-size-rescue';
      this.callout.hidden = true;
      this.rescueHeading = document.createElement('h3');
      this.rescueIntro = document.createElement('p');
      this.rescueGrid = document.createElement('div');
      this.rescueGrid.className = 'bt-size-rescue__grid';
      this.rescueBrowse = document.createElement('a');
      this.rescueBrowse.className = 'bt-size-rescue__browse';
      this.rescueBrowse.href = '#' + this.id;
      this.rescueBrowse.addEventListener('click', event => {event.preventDefault();event.stopPropagation();this.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});});
      this.callout.append(this.rescueHeading,this.rescueIntro,this.rescueGrid,this.rescueBrowse);
      this.attachCallout = () => {
        const info = document.querySelector('[id^="ProductInfoWrapper"]');
        if (info && !this.callout.isConnected) info.append(this.callout);
      };
      this.update = () => {
        const checked = [...document.querySelectorAll('[id^="ProductInfoWrapper"] input[type="radio"]:checked')].map(input => input.value);
        const current = this.currentVariants.find(variant => variant.options.every(value => checked.includes(value)));
        this.size = current?.size || this.dataset.size;
        const matching = this.cards.map(card => ({...card,variant:card.variants.find(variant => this.normalize(variant.size) === this.normalize(this.size))})).filter(card => card.variant);
        const visible = matching.slice(this.offset,this.offset+3);
        this.cards.forEach(card => card.element.hidden = !visible.some(item => item.element === card.element));
        visible.forEach(({element,variant}) => {
          const image = element.querySelector('img');
          if (image.getAttribute('src') !== variant.image) {image.src = variant.image;image.removeAttribute('srcset');}
          image.alt = variant.alt;
          element.querySelectorAll('[data-product-link]').forEach(link => link.href = variant.url);
          element.querySelector('input[name="id"]').value = variant.id;
          element.querySelector('[data-price]').textContent = variant.price;
          element.querySelector('[data-stock-label]').textContent = this.dataset.stock.replace('[size]',variant.title);
          element.querySelector('button[type="submit"]').textContent = this.dataset.add.replace('[size]',variant.size);
        });
        this.querySelector('[data-size-label]').textContent = this.size;
        this.querySelector('h2').textContent = current?.available === false ? this.dataset.soldHeading : this.dataset.heading;
        const browse = this.querySelector('[data-browse]');
        const url = new URL(browse.href); url.searchParams.set('filter.v.option.size',this.size); browse.href = url.href;
        this.querySelector('[data-more]').hidden = matching.length <= 3;
        this.querySelector('.bt-alternatives__empty').hidden = matching.length > 0;
        this.matchCount = matching.length;
        this.callout.hidden = current?.available !== false || matching.length === 0;
        this.rescueHeading.textContent = this.dataset.rescueHeading.replace('[size]',this.size);
        this.rescueIntro.textContent = this.dataset.rescueIntro.replace('[size]',this.size);
        this.rescueBrowse.textContent = this.dataset.rescueBrowse.replace('[size]',this.size).replace('[count]',matching.length) + ' →';
        this.rescueGrid.replaceChildren();
        if (!this.callout.hidden) matching.slice(0,3).forEach(({element,variant}) => {
          const link = document.createElement('a');
          link.className = 'bt-size-rescue__card';
          link.href = variant.url;
          const image = document.createElement('img');
          image.src = variant.image;
          image.alt = '';
          image.width = 160; image.height = 180;
          const title = document.createElement('strong');
          title.textContent = element.querySelector('h3').textContent.trim();
          const detail = document.createElement('span');
          detail.textContent = variant.size + ' · ' + variant.price;
          link.append(image,title,detail);
          this.rescueGrid.append(link);
        });
        this.attachCallout();
        const status = this.querySelector('[data-status]');
        status.textContent = status.dataset.template.replace('[count]',visible.length).replace('[size]',this.size);
      };
      this.onChange = event => {
        if (!event.target.matches('[id^="ProductInfoWrapper"] input[type="radio"]')) return;
        this.offset = 0; this.update();
      };
      this.onSizeLink = event => {event.preventDefault();document.querySelector('[id^="ProductInfoWrapper"]')?.scrollIntoView({block:'start',behavior:'smooth'});};
      this.querySelector('[data-change-size]').addEventListener('click',this.onSizeLink);
      this.onMore = () => {this.offset = this.offset+3 >= this.matchCount ? 0 : this.offset+3; this.update();};
      document.addEventListener('change',this.onChange);
      this.querySelector('[data-more]').addEventListener('click',this.onMore);
      const main = document.querySelector('[id^="shopify-section-"][id$="__main"]');
      this.observer = new MutationObserver(() => {if (!this.callout.isConnected) {this.attachCallout();this.update();}});
      if (main) this.observer.observe(main,{childList:true,subtree:true});
      this.visibilityObserver = new IntersectionObserver(entries => {document.body.classList.toggle('bt-alternatives-in-view',entries.some(entry => entry.intersectionRatio > 0.12));},{threshold:[0,0.12]});
      this.visibilityObserver.observe(this);
      this.initialized = true;
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('change',this.onChange);
      this.querySelector('[data-more]')?.removeEventListener('click',this.onMore);
      this.querySelector('[data-change-size]')?.removeEventListener('click',this.onSizeLink);
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      document.body.classList.remove('bt-alternatives-in-view');
      this.callout?.remove();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-size-lineup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-size-lineup')) {
  customElements.define('bt-size-lineup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-lineup-card]')).map(card => ({
        card,
        variants: JSON.parse(card.querySelector('[data-lineup-variants]').textContent),
        link: card.querySelector('a'),
        price: card.querySelector('[data-lineup-price]'),
        cta: card.querySelector('[data-lineup-cta]'),
        defaultCta: card.querySelector('[data-lineup-cta]').textContent,
        sizeIndex: Number(card.dataset.sizeIndex)
      }));
      this.querySelector('fieldset').hidden = false;
      this.addEventListener('change', event => {
        if (event.target.matches('.bt-lineup__radio')) this.filterSize(event.target.value);
      });
      this.filterSize('');
    }
    filterSize(size) {
      let count = 0;
      for (const item of this.cards) {
        const variant = item.variants.find(variant => variant.available && (!size || variant.options[item.sizeIndex] === size));
        item.card.hidden = !variant;
        if (!variant) continue;
        count++;
        const url = new URL(item.card.dataset.productUrl, window.location.origin);
        if (size) url.searchParams.set('variant', String(variant.id));
        item.link.href = url.pathname + url.search;
        item.price.textContent = variant.price;
        item.cta.textContent = size ? this.dataset.shopTemplate.replace('[size]', size) : item.defaultCta;
      }
      this.querySelector('[role="status"]').textContent = this.dataset.countTemplate.replace('[count]', String(count));
      this.querySelector('.bt-lineup__empty').hidden = count !== 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-solid-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-solid-edit')){
  customElements.define('bt-solid-edit',class extends HTMLElement{
    connectedCallback(){
      const init=()=>{
        if(this.ready)return;
        this.ready=true;
        this.items=JSON.parse(this.querySelector('[data-solid-data]').textContent);
        if(!this.items.length)return;
        this.current=this.items[0].id;
        this.size='';
        const normalize=value=>({SMALL:'S',MEDIUM:'M',LARGE:'L',XXL:'2XL',XXXL:'3XL'})[String(value).toUpperCase()]||String(value).toUpperCase();
        this.normalize=normalize;
        const params=new URL(location.href).searchParams;
        const requested=normalize(params.get('bt_size')||params.get('filter.v.option.size')||'');
        const input=[...this.querySelectorAll('input[type=radio]')].find(x=>x.value===requested);
        if(input){input.checked=true;this.size=requested;}
        this.addEventListener('click',event=>{
          const pick=event.target.closest('[data-solid-pick]');
          if(!pick)return;
          event.preventDefault();
          if(pick.getAttribute('aria-disabled')==='true')return;
          this.current=Number(pick.dataset.solidPick);
          this.update();
        });
        this.addEventListener('change',event=>{
          if(event.target.matches('[data-solid-variant]')){
            const item=this.items.find(item=>item.id===Number(event.target.dataset.solidVariant));
            const variant=item.variants.find(variant=>String(variant.id)===event.target.value);
            item.selected=variant?.id;
            if(variant){
              this.size=this.normalize(variant.size);
              this.querySelectorAll('input[type=radio]').forEach(input=>input.checked=input.value===this.size);
            }else{this.size='';this.querySelectorAll('input[type=radio]').forEach(input=>input.checked=input.value==='');}
            this.update();
            const url=new URL(location.href);url.searchParams.delete('filter.v.option.size');if(this.size)url.searchParams.set('bt_size',this.size);else url.searchParams.delete('bt_size');history.replaceState({},'',url);
          }else if(event.target.matches('input[type=radio]')){
            this.size=event.target.value;
            this.update();
            const url=new URL(location.href);
            url.searchParams.delete('filter.v.option.size');
            if(this.size)url.searchParams.set('bt_size',this.size);else url.searchParams.delete('bt_size');
            history.replaceState({},'',url);
          }
        });
        this.update();
      };
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    }
    match(item){const variants=item.variants.filter(variant=>!this.size||this.normalize(variant.size)===this.size);return variants.find(variant=>variant.id===item.selected)||variants[0];}
    update(){
      const available=this.items.filter(item=>this.match(item));
      if(!available.some(item=>item.id===this.current))this.current=available[0]?.id;
      this.querySelectorAll('[data-solid-pick]').forEach(pick=>{
        const item=this.items.find(product=>product.id===Number(pick.dataset.solidPick));
        pick.setAttribute('aria-disabled',String(!this.match(item)));
        pick.setAttribute('aria-current',String(item.id===this.current));
      });
      this.querySelectorAll('[data-solid-visual],[data-solid-info],[data-solid-shop],[data-solid-form]').forEach(element=>{
        const id=Number(element.dataset.solidVisual||element.dataset.solidInfo||element.dataset.solidShop||element.dataset.solidForm);
        element.hidden=id!==this.current;
      });
      const selected=this.items.find(item=>item.id===this.current);
      if(selected){
        const variant=this.match(selected);
        const form=this.querySelector('[data-solid-form="'+selected.id+'"]');
        const select=form.querySelector('select');
        Array.from(select.options).forEach(option=>{
          if(!option.value)return;
          const itemVariant=selected.variants.find(v=>String(v.id)===option.value);
          const excluded=!!this.size&&this.normalize(itemVariant.size)!==this.size;
          option.hidden=excluded;option.disabled=excluded;
        });
        select.value=this.size?String(variant.id):'';
        select.options[0].disabled=!!this.size;
        form.querySelector('button').disabled=!select.value;
        const info=this.querySelector('[data-solid-info="'+selected.id+'"]');
        info.querySelector('[data-solid-price]').textContent=variant.price;
        const compare=info.querySelector('[data-solid-compare]');
        compare.hidden=!variant.compare;compare.textContent=variant.compare||'';
        const link=this.querySelector('[data-solid-shop="'+selected.id+'"]');
        link.href=this.size?variant.url:selected.url;
        const label=link.querySelector('span');
        label.textContent=this.size?label.dataset.sized.replace('__size__',this.size):label.dataset.default;
        const image=this.querySelector('[data-solid-visual="'+selected.id+'"] .bt-solids__polo');
        const src=variant.image||selected.image;
        image.removeAttribute('srcset');image.src=src;
      }
      const status=this.querySelector('[data-solid-status]');
      status.textContent=(this.size?status.dataset.count:status.dataset.all).replace('__count__',available.length).replace('__size__',this.size);
      this.querySelector('[data-solid-empty]').hidden=available.length>0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-tee-bar"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-tee-bar'))customElements.define('bt-tee-bar',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.normalize=value=>({small:'s',medium:'m',large:'l',xxl:'2xl',xxxl:'3xl',xxxxl:'4xl'})[String(value).toLowerCase().trim()]||String(value).toLowerCase().trim();
    this.cards=[...this.querySelectorAll('[data-tee-card]')].map(element=>({element,variants:JSON.parse(element.querySelector('[data-tee-variants]').textContent),color:null}));
    this.size='';
    const initial=new URLSearchParams(location.search).get('bt_size');
    const allSizes=new Set(this.cards.flatMap(card=>card.variants.map(v=>this.normalize(v.size))));
    if(initial&&allSizes.has(this.normalize(initial)))this.size=this.normalize(initial);
    this.querySelectorAll('[data-tee-size]').forEach(button=>button.hidden=!!button.dataset.teeSize&&!allSizes.has(this.normalize(button.dataset.teeSize)));
    this.paint=(card,variant)=>{
      const e=card.element;
      e.querySelectorAll('[data-tee-link]').forEach(a=>a.href=variant.url);
      const image=e.querySelector('.bt-tees__photo img');if(image.getAttribute('src')!==variant.image){image.src=variant.image;image.removeAttribute('srcset');}image.alt=variant.alt;
      e.querySelector('[data-tee-price]').textContent=variant.price;
      e.querySelector('[data-tee-choice]').textContent=this.dataset.selected.replace('[option]',variant.title);
      const select=e.querySelector('[data-tee-variant]');
      if(this.size||card.explicit)select.value=String(variant.id);else select.value='';
      e.querySelector('[data-tee-add]').disabled=!select.value;
      e.querySelectorAll('[data-tee-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.teeColor===variant.color)));
      card.color=variant.color;
    };
    this.update=()=>{
      let count=0;
      this.cards.forEach(card=>{
        const variants=card.variants.filter(v=>!this.size||this.normalize(v.size)===this.size);
        const select=card.element.querySelector('[data-tee-variant]');
        Array.from(select.options).forEach(option=>{if(!option.value)return;const excluded=!!this.size&&this.normalize(option.dataset.size)!==this.size;option.hidden=excluded;option.disabled=excluded;});
        card.element.hidden=!variants.length;if(!variants.length)return;count++;
        const previous=variants.find(v=>String(v.id)===select.value);
        const variant=previous||variants.find(v=>v.color===card.color)||variants[0];
        const colors=card.element.querySelector('[data-tee-colors]');colors.replaceChildren();
        const seen=new Set();variants.forEach(v=>{
          if(!v.color||seen.has(v.color))return;seen.add(v.color);
          const button=document.createElement('button');button.type='button';button.dataset.teeColor=v.color;button.setAttribute('aria-label',v.color);button.title=v.color;
          const img=document.createElement('img');const thumbnail=new URL(v.image,location.href);thumbnail.searchParams.set('width','80');img.src=thumbnail.href;img.alt='';img.width=35;img.height=39;img.loading='lazy';button.append(img);colors.append(button);
        });colors.hidden=seen.size<2;
        this.paint(card,variant);
      });
      this.querySelectorAll('[data-tee-size]').forEach(b=>b.setAttribute('aria-pressed',String(this.normalize(b.dataset.teeSize)===this.size)));
      this.querySelector('[data-tee-count]').textContent=this.dataset.count.replace('[count]',count).replace('[size]',this.size?this.size.toUpperCase():this.dataset.all);
      this.querySelector('[data-tee-empty]').hidden=count>0;
    };
    this.click=event=>{
      const size=event.target.closest('[data-tee-size]');const color=event.target.closest('[data-tee-color]');
      if(size||event.target.closest('[data-tee-reset]')){
        this.size=size?this.normalize(size.dataset.teeSize):'';this.cards.forEach(card=>{card.explicit=false;card.element.querySelector('[data-tee-variant]').value=''});this.update();
        const url=new URL(location.href);if(this.size)url.searchParams.set('bt_size',this.size.toUpperCase());else url.searchParams.delete('bt_size');history.replaceState(null,'',url);
      }else if(color){
        const card=this.cards.find(c=>c.element===color.closest('[data-tee-card]'));
        const selected=card.variants.find(v=>String(v.id)===card.element.querySelector('[data-tee-variant]').value);
        const activeSize=this.size||(selected?this.normalize(selected.size):'');
        const variant=card.variants.find(v=>v.color===color.dataset.teeColor&&(!activeSize||this.normalize(v.size)===activeSize));
        if(variant)this.paint(card,variant);
      }
    };
    this.change=event=>{
      if(!event.target.matches('[data-tee-variant]'))return;
      const card=this.cards.find(c=>c.element===event.target.closest('[data-tee-card]'));
      const variant=card.variants.find(v=>String(v.id)===event.target.value);
      card.explicit=!!variant;
      if(variant)this.paint(card,variant);else card.element.querySelector('[data-tee-add]').disabled=true;
    };
    this.addEventListener('change',this.change);
    this.addEventListener('click',this.click);this.querySelector('[data-tee-filters]').hidden=false;this.update();
  }
  disconnectedCallback(){this.removeEventListener('click',this.click);this.removeEventListener('change',this.change);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bt-fit-entry')) {
  customElements.define('bt-fit-entry', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = event => {
        const room = document.querySelector('bt-scorecard');
        if (!room || !event.target.closest('a') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); event.stopPropagation();
        room.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      this.addEventListener('click',this.bound);
    }
    disconnectedCallback() {this.removeEventListener('click',this.bound);this.bound=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
